<template>
    <div>
      <credit-card-list></credit-card-list>
    </div>
  </template>
  
  <script>
  export default {};
  </script>
  